import {Injectable, Inject} from 'ng-metadata/core';
import {PushtoService} from "../pushto.service";
import {JwtUtilService} from '../../../security/jwtUtil.service';
import {LoginService} from '../../../security/login/login.service';

@Injectable()
export class LegantoService {

    private popupWin: Window;
    public responseLists = [];
    private item: Object;
    private selectedIds: Object;
    private statusMessage: String;
    public showTemplateType: String;
    public showSpinner: String;
    private noListsMessage= "";
    private pushAllowed: boolean;

    constructor(private pushtoService: PushtoService,
                private jwtUtilService : JwtUtilService,
                private loginService: LoginService,
                @Inject('$mdDialog') private $mdDialog:  angular.material.IDialogService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
        ){

        this.$mdDialog = $mdDialog;
        this.$translate = $translate;

         // hold all translations codes that may be used in this file
        this.$translate([   'fulldisplay.command.pushto.option.LegantoPushTo.alert.okButton',
                            'fulldisplay.command.pushto.option.LegantoPushTo.list',
                            'fulldisplay.command.pushto.option.LegantoPushTo.collection',
                            'fulldisplay.command.pushto.option.LegantoPushTo.citationAdded.list',
                            'fulldisplay.command.pushto.option.LegantoPushTo.citationAdded.collection',
                            'fulldisplay.command.pushto.option.LegantoPushTo.citationAdded.error',
                            'fulldisplay.command.pushto.option.LegantoPushTo.getLists.error',
                            'fulldisplay.command.pushto.option.LegantoPushTo.noLists',
                            'fulldisplay.command.pushto.option.LegantoPushTo.add'
                        ]).then((translations)=> {this.translations = translations});
    }

    // called when clicked on Leganto icon
    public legantoAction(item,selectedIds){
        if(this.isGuest()){
            this.showTemplateType = "signIn";
        }
        else {
            this.statusMessage = ""; // remove any existing messages
            this.item = item;
            this.selectedIds = selectedIds;
            return this.getListFromLeganto();
        }
    }

    public getListFromLeganto() {
        this.showSpinner = "show";
        let pushtoPromise = this.pushtoService.getServiceUrl([this.item], this.selectedIds, 'leganto',{action: "get_lists"});

        pushtoPromise.then((response)=>this.successfullFetchLists(response), (response)=>this.failedFetchLists(response));

        return pushtoPromise;
    }

    public pushRecord(selectedUserList, selectedUserSection) {
        let failedAction = angular.bind(this, this.failedPushtoAction);
        let successAction = angular.bind(this, this.successfullPushtoAction);
        let pushtoPromise = null;
        let pushToOptions = (selectedUserList !== "" && selectedUserSection !== "") ? "list" : "collection";
        this.showSpinner = "show";
        if(pushToOptions === "list"){ // push to list
            pushtoPromise = this.pushtoService.getServiceUrl([this.item], this.selectedIds, 'leganto',{action: 'list', listId: selectedUserList, sectionId: selectedUserSection});
        }
        else { //push to collection
            pushtoPromise = this.pushtoService.getServiceUrl([this.item], this.selectedIds, 'leganto',{action: 'collection'});
        }
        pushtoPromise.then((response)=>successAction(response, pushToOptions), (response)=>failedAction(response));
        return pushtoPromise;
    }

    public successfullFetchLists(response) {
        this.showSpinner = "";
        if(response.data.error){
            this.failedFetchLists(response);
        }
        else {
            this.responseLists = response.data.lists;
            console.log("Leganto successfully fetched");
            if(response.data.lists.length <= 0){
                this.showTemplateType = "noListsExist";
                this.noListsMessage = this.translations['fulldisplay.command.pushto.option.LegantoPushTo.noLists'];
                this.pushAllowed = true;
            }
            else {
                this.showTemplateType = "userSelection";
            }
        }
    }

    public failedFetchLists(response) {
        this.showSpinner = "";
        console.log("Leganto call failed");

        if(!response.data || (response.data && response.data.error)){
            console.log(response.data.error);
            this.showMessage('fulldisplay.command.pushto.option.LegantoPushTo.getLists.error', 'error');
        }
        response.setSelectedAction = false; // it will indicate the actionList if to open the box or just to alert a message
    }

    public successfullPushtoAction(response, pushToOptions) {
        this.showSpinner = "";
        if(response.data.error){
            this.showMessage('fulldisplay.command.pushto.option.LegantoPushTo.citationAdded.error', 'error');
        }
        else {
            this.showMessage('fulldisplay.command.pushto.option.LegantoPushTo.citationAdded.'+pushToOptions);
        }
    }

    public failedPushtoAction(response) {
        this.showSpinner = "";
        this.showMessage('fulldisplay.command.pushto.option.LegantoPushTo.citationAdded.error', "error");
    }

    public getResponseLists() {
        return this.responseLists;
    }

    // Display the status message
    public showMessage(code, error) {
        this.statusMessage = this.translations[code];
        if(error){ // error message will be displayed in red on the Leganto's template
            this.showTemplateType = "error";

        }
        else {
            // Success messages are not displayed
        }
    }

    public isGuest(){
        return this.jwtUtilService.isGuest();
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/legantoAction/leganto.service.ts